import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema, useTheme } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";

/*
 *  Section Management Services
 * !== 섹션 관리 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/usr/sctn`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/usr/sctn`,
    nodes: [],
};

export const URLS = {
    ptli0918001q: `${BASE.path}/ptli0918001q`, // Section List !==  섹션 목록 ==!
    ptli0918002s: `${BASE.path}/ptli0918002s`, // Section Registration !==  섹션 등록 ==!
    ptli0918003q: `${BASE.path}/ptli0918003q`, // Section information details !==  섹션 정보 상세 ==!
    ptli0918004s: `${BASE.path}/ptli0918004s`, // Edit Section information !==  섹션 정보 수정 ==!
};

export const APIS = {
    // Get a list of sections !== 섹션 목록 조회==!
    getSctnList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Get section details !== 섹션 상세정보 조회==!
    getSctnInfo: (cstmOrgzCd: any) => {
        return api.get(`${BASE.api}/${cstmOrgzCd}`);
    },
    // Create section information. !== 섹션 정보 생성 ==!
    createSctnInfo: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
    // Update section information. !== 섹션 정보 수정 ==!
    updateSctnInfo: (data: any) => {
        return api.put(`${BASE.api}`, {
            ...data,
        });
    },
    // Delete section information. !== 섹션 정보 삭제 ==!
    deleteSctnInfo: (cstmOrgzCd: any) => {
        return api.delete(`${BASE.api}/${cstmOrgzCd}`);
    },
};

export const SF_SCTN_SRCH: TFormSchema = {
    id: "form_sctnSrch",
    schema: {
        cstmOrgzCd: { type: "code", label: "L_CSTM_ORGZ_CD", area: "cstmOrgzCd" },
        cstmOrgzTpCd: {
            type: "select",
            label: "L_CSTM_ORGZ_TP_CD",
            all: true,
            area: "comnCd",
            comnCd: "PTL0021",
            excludes: ["C"],
        },
        cstmOrgzNm: { type: "text", label: "L_CSTM_ORGZ_NM" },
    },
};

export const SG_SCTN_LIST: TGridSchema = {
    id: "grid_sctnList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_CSTM_ORGZ_CD", binding: "cstmOrgzCd", width: "20%" }] },
        { cells: [{ header: "L_CSTM_ORGZ_TP_NM", binding: "cstmOrgzTpNm", width: "20%" }] },
        { cells: [{ header: "L_CSTM_ORGZ_NM", binding: "cstmOrgzNm", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "cstmOrgzCd" }],
        },
        {
            cells: [{ binding: "cstmOrgzTpNm" }],
        },
        {
            cells: [{ binding: "cstmOrgzNm", align: "left" }],
        },
    ],
};

export const SF_SCTN_INFO: TFormSchema = {
    id: "form_sctnInfo",
    schema: {
        cstmOrgzTpCd: {
            type: "select",
            label: "L_CSTM_ORGZ_TP_CD",
            area: "comnCd",
            comnCd: "PTL0021",
            excludes: ["C"],
            labelSize: 3,
        },
        cstmOrgzCd: { type: "text", label: "L_CSTM_ORGZ_CD", maxLength: 6, required: true, labelSize: 3 },
        cstmOrgzNmTz: { type: "text", label: "L_CSTM_ORGZ_NM_TZ", maxLength: 100, labelSize: 3 },
        cstmOrgzNmEn: { type: "text", label: "L_CSTM_ORGZ_NM_EN", maxLength: 100, labelSize: 3 },
        cstmOrgzNmKo: { type: "text", label: "L_CSTM_ORGZ_NM_KO", maxLength: 100, labelSize: 3 },
    },
};
